var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g({ref:"element",on:{"change":_vm.action,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.action.apply(null, arguments)}}},Object.assign({}, ( _vm.mask && {
            input: _vm.validateMask
        }))))}
var staticRenderFns = []

export { render, staticRenderFns }